module.exports = __webpack_public_path__ + "img/20-Aluminium Brush Effect.jpg";